export default class NavbarData
{

  
/** @type {NavbarItem[]} */
NavbarItems = [];

/** @type {string} */ 
LogoName;
/** @type {string} */
LogoLinkTo;
}